import { Button } from "../ui/button";
import { cn } from "@utils/cn";
import BtnCancel from "../ui/button/btn-cancle";
import BtnSuccess from "../ui/button/btn-success";

export default function ModalButtonContainer({
  onClose,
  onConfirm,
  cancelText,
  confirmText,
}: {
  onClose: () => void;
  onConfirm: () => void;
  cancelText: string;
  confirmText: string;
  disabled?: boolean;
  cancelButtonClassName?: string;
  confirmButtonClassName?: string;
}) {
  return (
    <div className="flex gap-2 justify-center">
      <BtnCancel onClick={onClose}>{cancelText}</BtnCancel>
      <BtnSuccess onClick={onConfirm}>{confirmText}</BtnSuccess>
    </div>
  );
}
